import {withProps} from 'recompose'
import {prepareOptions} from '../common/helper'

const withOptions = () =>
  withProps(props => ({
    // options: prepareOptions(props.options) || [],
  }))

export default withOptions
